import React, {Component} from  "react";
import { connect } from "react-redux";
import { updateAppClosedStatus } from '../../action/morpheus.state.action'
import {Icon, Tooltip} from 'antd'
import * as keys from '../neoviewer/apps/app_keys'
import cookie from 'react-cookies';
import "../../asset/style/utils/app.css"

class AppIcon extends Component {
    constructor(props) {
        super(props);

        this.openable = this.props.openable === undefined ? true : this.props.openable;
        this.isMobile = cookie.loadAll().isMobile === 'true';
    }

    toggleShowApp = (e) => {
        let closed = !this.props.appState[this.props.appKey.id].closed;
        if (!closed && this.isMobile) {
            for (let app in keys) {
                if (keys[app].id != this.props.appKey.id) {
                    this.props.dispatch(updateAppClosedStatus(keys[app].id, true));
                }
            }
        }
        this.props.dispatch(updateAppClosedStatus(this.props.appKey.id, closed));
        e.stopPropagation();
    }

    closeApp = (e) => {
        this.props.dispatch(updateAppClosedStatus(this.props.appKey.id, true));
        e.stopPropagation();
    }

    render() {

        let closeButton = undefined;

        if (!(this.props.appState[this.props.appKey.id] || {}).closed) {
            closeButton = <div 
                            className="app-icon-closeable-handle" 
                            onClick={this.closeApp}>
                            <Tooltip 
                                title="Click to Close"
                                placement="right"
                                overlayStyle={{
                                    fontSize:"10px"
                                }}>
                                <Icon className="app-icon-close" type="close-circle" theme="twoTone" twoToneColor="#de2323"/>   
                            </Tooltip> 
                        </div>
        }

        return (
            <div 
                className={"app-icon " + ((this.props.appState[this.props.appKey.id] || {}).closed || !this.openable ? "" : " app-icon-open")} 
                onClick={this.openable ? this.toggleShowApp : () => {}}>
                {this.openable ? closeButton : undefined}
                <div>
                    {this.props.content}
                </div>
                <div className="app-icon-text unselectable">
                    {this.props.appKey.title}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
  return {
      appState: state.viewerUrlReducer.app_state
  };
};

export default connect(mapStateToProps)(AppIcon);